<template lang="html">
  <v-layout row>
    <v-flex xs12>
      <v-card>
        <v-card-title primary-title class="grey lighten-4">
          <v-tooltip top>
                  <v-btn
                        slot="activator"
                        dark
                        @click.stop="dialog = true"
                        icon class="mx-0">
                     <v-icon color="red">help</v-icon>
                 </v-btn>
             <span>Estudios adicionales</span>
          </v-tooltip>
          <h3 class="headline mb-0">Administración de Especialidades</h3>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark class="mb-2" @click="nuevaEspecialidad">Agregar</v-btn>
        </v-card-title>
          <v-card-title primary-title class="grey lighten-4">
            <v-spacer></v-spacer>
            <v-text-field
              :loading="loading"
              v-model="search"
              label="Buscar"
              single-line
              hide-details
              :append-outer-icon="loading ? 'update' : 'search'"
              @click:append-outer="searchFilterSpecialty"
              @change="searchFilterSpecialty"
            ></v-text-field>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-data-table
               :loading="loading"
               :headers="headers"
               :items="specialties"
               rows-per-page-text="Filas por Pág"
               hide-actions
               :pagination.sync="pagination"
             >
               <template slot="items" slot-scope="props">

                 <td>{{ (props.item.specialty_id == null) ? props.item.name : props.item.especialidad}}</td>
                 <td>{{ (props.item.specialty_id != null) ? props.item.name : ''}}</td>

                 <td class="justify-center layout px-0">
                    <v-tooltip top>
                        <v-btn slot="activator" icon class="mx-0" @click="verEspecialidad(props)">
                          <v-icon color="blue darken-2">description</v-icon>
                        </v-btn>
                        <span>Ver</span>
                    </v-tooltip>

                    <v-tooltip top>
                        <v-btn slot="activator" icon class="mx-0" >
                          <v-icon color="green">edit</v-icon>
                        </v-btn>
                        <span>Editar Especialidad</span>
                    </v-tooltip>

                   <v-tooltip top>
                        <v-btn slot="activator" icon class="mx-0">
                          <v-icon color="red">delete</v-icon>
                        </v-btn>
                        <span>Eliminar Especialidad</span>
                    </v-tooltip>

                 </td>
               </template>
               <v-alert slot="no-results" :value="true" color="error" icon="warning">
                 La busqueda para  "{{ search }}" No resultó.
               </v-alert>
             </v-data-table>

            <div class="text-xs-center">
                <v-layout justify-center>
                  <v-flex xs8>
                    <v-card class="elevation-0">
                      <v-card-text>
                        <v-pagination
                          v-model="page"
                          :length="pages"
                        ></v-pagination>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
            </div>

          </v-card-text>
      </v-card>
    </v-flex>

  <!-- dialog para form especialidades -->
    <v-dialog
      v-model="dialogFormSpecialty"
      width="600"
    >
      <FormSpecialties :tipo="tipo" :datos="sub_specialties" :editvalue="getSpecialties" v-on:closeDialogSpecialty="closeDialogSpecialty($event)" />
    </v-dialog>
    <!-- fin dialog form especialidades -->

    <!-- Inicio de dialogo -->
    <v-dialog
      v-model="dialog"
      max-width="600"
    >
      <v-card>
        <v-card-title class="headline">Especialiades Profesionales</v-card-title>

        <v-card-text>
          Lista de especialidades profesionales adicionales al pre-grado para la carga por cada agremiado desde el portal.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            flat="flat"
            @click="dialog = false"
          >
            Salir
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Fin de dialogo -->

  </v-layout>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import FormSpecialties from '~/components/form/formSpecialties.vue'

export default {
    name: 'specialties-view',

    components: {
      FormSpecialties
    },

    computed: {
        ...mapGetters({
            authenticated: 'authCheck'
        }),
        getSpecialties () {
          return this.editItem
        },
        pages () {
            return this.pagination.total
        }
    },

    mounted() {
        this.initComponent(1)
    },

    watch: {
      page(v) {
        if(this.activePagination){
          this.initComponent(v)
        }
        this.activePagination = true
      }
    },

    data () {
        return {
            dialog: false,
            specialties: [],
            sub_specialties: [],
            all_specialties: [],
            dialogFormSpecialty: false,
            activePagination: false,
            loading: false,
            search: '',
            page: 0,
            tipo: '',
            editItem: {},
            pagination: {
                page: 1,
                totalItems: 0,
                rowsPerPage: 10,
                total: 0
            },
            headers: [
                { text: 'ESPECIALIDAD', value: 'especialidad', sortable: false },
                { text: 'SUB-ESPECIALIDAD', value: 'name', sortable: false },
                { text: 'ACCIONES', value: 'acciones', sortable: false }
            ],
        }
    },

    methods: {

        async initComponent (page,search=null) {
            this.loading = true
            const url = search == null ? `/api/specialties/admin/getSpecialties?page=${page}` : `/api/specialties/admin/getSpecialties?page=${page}&search=${search}`
            await axios.get(url)
                .then(resp => {
                  console.log(resp)
                    this.sub_specialties = resp.data.sub_specialties
                    this.specialties = resp.data.specialties.data
                    this.page = resp.data.specialties.current_page
                    this.pagination = {
                        total: resp.data.specialties.last_page,
                        totalItems: resp.data.specialties.total,
                        rowsPerPage: resp.data.specialties.per_page,
                        page: 1
                    }
                })
                .catch(e => {
                    console.log(e.response,"error");
                })

            this.loading = false
        },

        nuevaEspecialidad () {
          this.tipo = "crear"
          this.editItem = {}
          this.dialogFormSpecialty = true
        },

        verEspecialidad (props) {
          this.tipo = "ver"
          this.editItem = props.item
          this.dialogFormSpecialty = true
        },

        eliminarEspecialidad (id) {
        axios.delete('/api/specialties/admin/' + id)
        .then(response => {
          console.log(response)
          this.searchFilterSpecialty()
        })
        .catch(error => {
           console.log(error.response);
        });
    },

        editarEspecialidad (props) {
          this.tipo = "editar"
          this.editItem = props.item
          this.dialogFormSpecialty = true
        },
        setUsersData (props) {
          let item = this.users.find(users => users.id === props.id)
          Object.assign(item, props)
        },

        searchFilterSpecialty () {
            this.initComponent(this.page,this.search)
        },

        closeDialogSpecialty (response) {
          if (response != null) {
            var item = this.all_specialties.find(all_universitie => all_universitie.id === response.id)
            if (this.tipo == 'crear') {
              this.all_specialties.push(response)
            }else {
              Object.assign(item, response)
            }
            //this.search = response.email
          }
          this.dialogFormSpecialty = false
          setTimeout(function(){
            this.editItem = {}
            this.tipo = ''
          }, 3000)
          this.searchFilterSpecialty()
        }

    }

}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/atencion/specialties.vue